import moment from "moment";
import _ from 'underscore';
import i18n from 'l10n';
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import ServiceReportContentsView from 'js/views/service.report.contents.view';
import VoucherRedemptionCollection from 'js/models/voucher.redemption.paginated.collection';
import SurveyCompletionCollection from 'js/models/survey.filledin.paginated.collection';
import OptinAcquisitionsCollection from 'js/models/optin.acquisitions.paginated.collection';
import InstantWinAcquisitionsCollection from 'js/models/instantWin.acquisitions.paginated.collection';
import PayPalPaymentBuyersCollection from 'js/models/payPalPayment.buyers.paginated.collection';
import ServicesTimeReport from 'js/views/services-simpleview';
import Template from 'js/templates/service.report.hbs';
import SurveyComponentsStatsTemplate from 'js/templates/surveycomponentsstatsreport.hbs';
import Chart from 'chartjs';
import {debounce, el, on, tagName, template} from "../adapters/backbone-decorators";

require('jqueryUI');
require('metroHelpers');

class BaseAnswer {
    constructor(title, questionIndex) {
        this.title = title;
        this.questionIndex = questionIndex;
    }

    setQuestionIndex(value) {
        this.questionIndex = value;
        return this;
    }

    setTitle(title) {
        this.title = title;
        return this;
    }
}

class RequiredAnswer extends BaseAnswer {
    /**
     * @param {boolean} required
     * @returns {RequiredAnswer}
     */
    setRequired(required) {
        this.required = required;
        return this;
    }
}

class DateAnswer extends BaseAnswer {
    setDate(date) {
        this.date = date;
        return this;
    }

    getType() {
        return "DateAnswer";
    }
}

class MultipleChoiceAnswer extends RequiredAnswer {
    setTextQuestion(textQuestion) {
        this.textQuestion = textQuestion;
        return this;
    }

    setChoices(choices) {
        this.choices = choices;
        return this;
    }

    getType() {
        return "MultipleChoiceAnswer";
    }
}

class StarRatingAnswer extends RequiredAnswer {
    setNormalizedRating(normalizedRating) {
        this.normalizedRating = normalizedRating;
        return this;
    }

    setSize(size) {
        this.size = size;
        return this;
    }

    getType() {
        return "StarRatingAnswer";
    }
}

class FreeTextAnswer extends RequiredAnswer {
    setTextQuestion(textQuestion) {
        this.textQuestion = textQuestion;
        return this;
    }

    setTextAnswer(textAnswer) {
        this.textAnswer = textAnswer;
        return this;
    }

    getType() {
        return "FreeTextAnswer";
    }
}

class TextAnswer {
    constructor(answer, completion, hasPhoto) {
        const {text, normalizedRating} = answer;
        const {firstName, lastName, email, msisdn, subscriptionId, creationDate} = completion;
        this.text = text;
        this.normalizedRating = normalizedRating;
        this.subscription = {
            subscriber: {
                firstName,
                lastName,
                email,
                creationDate
            },
            msisdn,
            subscriptionId
        };
        this.hasPhoto = hasPhoto;
    }
}

function createAnswer(type, title, qid) {
    if (type === "SurveyStarRating") {
        return new StarRatingAnswer(title, qid);
    } else if (type === "SurveyFreeText") {
        return new FreeTextAnswer(title, qid);
    } else if (type === "SurveyMultipleChoice") {
        return new MultipleChoiceAnswer(title, qid);
    } else if (type === "SurveyDate") {
        return new DateAnswer(title, qid);
    }
}

@el("#service-report-container")
@tagName('div')
@template(Template)
class ServiceReportView extends GenericView {
    surveyComponentsStatsTemplate = Handlebars.compile(SurveyComponentsStatsTemplate);
    service = "";
    allSurveyAnswers = [];
    isAnimationOn = false;

    @debounce(800)
    @on('keyup .searchbox')
    searchByFilter(e) {

        const updateServiceReport = (viewName, collectionName, text) => {
            if (this[collectionName].length === 0) {
                const $noServicesSearch = $('#noServicesSearch');
                $noServicesSearch.text(i18n.t(text));
                $noServicesSearch.show();
                $('#noServicesYet').hide();
            }
        };

        /* TODO refactor the crap out of this*/
        const $filterButtons = $(".filterButtons");
        const elemVal = $(e.currentTarget).val();
        if (elemVal) {
            let text = elemVal.toLowerCase();
            const getUrl = report => `/CampaignCloud/Report/${this.serviceId}/${report}?filter=${encodeURIComponent(text)}`;
            if (this.service === 'Voucher') {
                this.VoucherRedemptionCollection.url = getUrl('getVoucherReportPerPage');
                this.VoucherRedemptionCollection.getFirstPage()
                    .then(updateServiceReport
                        .bind(this, "serviceReportContentsView", "VoucherRedemptionCollection", "nosuchservice"));
            } else if (this.service === "Survey") {
                this.SurveyCompletionCollection.url = getUrl('getSurveyReportPerPage');
                this.SurveyCompletionCollection.getFirstPage()
                    .then(updateServiceReport
                        .bind(this, "serviceReportContentsView", "SurveyCompletionCollection", "nosuchfilledinsurvey"));
            } else if (this.service === "Optin") {
                this.OptinAcquisitionsCollection.url = getUrl('getOptinReportPerPage');
                this.OptinAcquisitionsCollection.getFirstPage();
            } else if (this.service === "InstantWin" || this.service === "Quiz") {
                this.InstantWinAcquisitionsCollection.url = getUrl('getOptinReportPerPage');
                this.InstantWinAcquisitionsCollection.getFirstPage()
                    .then(updateServiceReport
                        .bind(this, "serviceReportContentsView", "InstantWinAcquisitionsCollection", "instantWin.noInstantWinSearch"));

            } else if (this.service === "PayPalPayment") {
                this.PayPalPaymentBuyersCollection.url = getUrl('getOptinReportPerPage');
                this.PayPalPaymentBuyersCollection.getFirstPage();

            }
        } else {
            const getUrl = report => `/CampaignCloud/Report/${this.serviceId}/${report}`;
            if (this.service === 'Voucher') {
                this.VoucherRedemptionCollection.url = getUrl('getVoucherReportPerPage');
                this.VoucherRedemptionCollection.getFirstPage();
            } else if (this.service === 'Survey') {
                this.SurveyCompletionCollection.url = getUrl('getSurveyReportPerPage');
                this.SurveyCompletionCollection.getFirstPage();
            } else if (this.service === 'Optin') {
                this.OptinAcquisitionsCollection.url = getUrl('getOptinReportPerPage');
                this.OptinAcquisitionsCollection.getFirstPage();
            } else if (this.service === 'InstantWin' || this.service === "Quiz") {
                this.InstantWinAcquisitionsCollection.url = getUrl('getOptinReportPerPage');
                this.InstantWinAcquisitionsCollection.getFirstPage();
            } else if (this.service === 'PayPalPayment') {
                this.PayPalPaymentBuyersCollection.url = getUrl('getOptinReportPerPage');
                this.PayPalPaymentBuyersCollection.getFirstPage();
            }
        }

        const filterRatings = $filterButtons.children(".filterRatings");
        if (!filterRatings.first().hasClass("active")) {
            $filterButtons.find(".active").removeClass("active");
            //add class "active" to the first Child, which is "ALL" button.
            filterRatings.first().addClass("active");
        }

    }

    constructor(options) {
        super(options);
        this.service = options.serviceType;
        this.isAnimationOn = false;
        this.serviceId = options.serviceId;
        this.isSweepstakes = options.isSweepstakes;
        this.campaignStatus = options.campaignStatus;
        this.description = options.description;
        this.qCollection = options.qCollection;
        this.isQuestion = function (type) {
            return ["SurveyImage", "SurveyFormattedText", "SurveySocialShare", "SurveySocialFollow"].indexOf(type) === -1;
        };
        this.renderCollection();
        this.loadAppropriateReport(options.components).finally(() => {
            const reportCollectionOfService = {
                "Voucher": this.VoucherRedemptionCollection,
                "Survey": this.SurveyCompletionCollection,
                "Quiz": this.InstantWinAcquisitionsCollection,
                "InstantWin": this.InstantWinAcquisitionsCollection,
                "PayPalPayment": this.PayPalPaymentBuyersCollection,
                "Optin": this.OptinAcquisitionsCollection
            };
            this.serviceReportContentsView = new ServiceReportContentsView({
                serviceCollection: reportCollectionOfService[this.service],
                serviceType: this.service,
                questions: this.questions,
                isSweepstakes: this.isSweepstakes,
                description: this.description
            });
            ServicesTimeReport.init("#serviceSentUsed", this.service, this.serviceId, options.isPostpaid, options.startDate); //init Services Used-Sent Line chart
        });
    }

    @on('click .filterRatings')
    filterRatings(event) {
        var filter = $(event.currentTarget).data("filter");
        $(".filterButtons").find(".active").removeClass("active");
        $(event.currentTarget).addClass("active");

        this.InstantWinAcquisitionsCollection.url = `/CampaignCloud/Report/${this.serviceId}/getOptinReportPerPage`;
        this.$(".searchbox").val("");

        switch (filter) {
            case "winners":
                filter = "Reacted_WINNER";
                break;
            case "losers":
                filter = "Reacted_LOSER";
                break;
        }
        if (filter !== "all") {
            this.InstantWinAcquisitionsCollection.url += `?filter=${filter}`;
        }
        this.InstantWinAcquisitionsCollection.getFirstPage();
    }

    async loadAppropriateReport(components) {
        if (this.service === "Voucher") {
            this.VoucherRedemptionCollection = new VoucherRedemptionCollection();
            return await this.loadVoucherReport();
        } else if (this.service === "Survey") {
            this.components = components;
            this.questions = _.filter(this.components, obj => this.isQuestion(obj.get("type")));
            this.SurveyCompletionCollection = new SurveyCompletionCollection();
            return await this.loadSurveyReport();
        } else if (this.service === "InstantWin" || this.service === "Quiz") {
            this.components = components;
            this.questions = _.filter(this.components, obj => this.isQuestion(obj.get("type")));
            this.InstantWinAcquisitionsCollection = new InstantWinAcquisitionsCollection();
            return await this.loadInstantWinReport();
        } else if (this.service === "PayPalPayment") {
            this.components = components;
            this.questions = _.filter(this.components, obj => this.isQuestion(obj.get("type")));
            this.PayPalPaymentBuyersCollection = new PayPalPaymentBuyersCollection();
            return await this.loadPayPalPaymentReport();
        } else {
            // Optin
            this.components = components;
            this.questions = _.filter(this.components, obj => this.isQuestion(obj.get("type")));
            this.OptinAcquisitionsCollection = new OptinAcquisitionsCollection();
            return await this.loadOptinReport();
        }
    }

    renderCollection() {
        var tempTemplate = this.template({
            serviceType: this.service,
            isSweepstakes: this.isSweepstakes,
            campaignStatus: this.campaignStatus
        });
        this.$el.html(tempTemplate);
    }

    async fillInAllSurveyAnswers() {

        try {
            const answers = await $.ajaxDefaultQ(`/CampaignCloud/Report/${this.serviceId}/getAllAnswersData`);

            var usersWithPhoto = this.SurveyCompletionCollection.usersWithPhoto;

            const flatMappedAnswers = !answers ? [] : answers.reduce((acc, ans, aid) => {

                const mappedToClass = this.questions.map((q, qid) => {
                    /** @namespace ans.surveyAnswerList */
                    const questionAnswer = ans.surveyAnswerList[qid];
                    const title = q.get('title');
                    const archetype = q.get("type");
                    const type = archetype === "CustomFieldComponent" || archetype === "CustomFieldMultipleChoiceComponent"
                        ? q.get("customFieldType") === "date"
                            ? "SurveyDate"
                            : "SurveyFreeText"
                        : archetype;

                    const answer = createAnswer(type, title, qid);

                    if (type === "SurveyStarRating") {

                        answer.setNormalizedRating(questionAnswer.normalizedRating)
                            .setSize(questionAnswer.size)
                            .setRequired(q.get("required"));

                    } else if (type === "SurveyFreeText") {

                        const hasPhoto = this.SurveyCompletionCollection.models[aid] &&
                            usersWithPhoto.includes(this.SurveyCompletionCollection.models[aid].get("subscriptionId"));
                        const textAnswer = new TextAnswer(questionAnswer, ans, hasPhoto);

                        answer.setTextQuestion(q.get("textQuestion"))
                            .setTextAnswer(textAnswer)
                            .setRequired(q.get("required"));

                    } else if (type === "SurveyMultipleChoice") {

                        answer.setTextQuestion(q.get('textQuestion'))
                            .setChoices([...questionAnswer.choices])
                            .setRequired(q.get('required'));

                    } else if (type === "SurveyDate") {

                        const parsedDate = moment(questionAnswer.text, "yyyy-mm-dd", true);
                        if (questionAnswer)
                            answer.setDate(parsedDate.isValid() ? parsedDate : moment(Number(questionAnswer.text)));

                    }

                    return answer;
                });
                return acc.concat(...mappedToClass);
            }, []);

            this.allSurveyAnswers = _.groupBy(flatMappedAnswers, a => a.getType());
        } catch (e) {
            console.error(e);
        }
    }

    fillInQuestionAnswerStarsChart(allSurveyAnswers) {
        let {
            /** @type Array<StarRatingAnswer>*/
            StarRatingAnswer: starRatingAnswers,
            /** @type Array<FreeTextAnswer>*/
            FreeTextAnswer: freeTextAnswers,
            /** @type Array<MultipleChoiceAnswer>*/
            MultipleChoiceAnswer: multipleChoiceAnswers,
            /** @type Array<DateAnswer>*/
            DateAnswer: surveyDateAnswers
        } = allSurveyAnswers;
        starRatingAnswers = starRatingAnswers || [];
        freeTextAnswers = freeTextAnswers || [];
        multipleChoiceAnswers = multipleChoiceAnswers || [];
        surveyDateAnswers = surveyDateAnswers || [];

        let questionAnswer = [], starRatingStats = [];
        const itemWithMaximumSize = _.max(starRatingAnswers, tempItem => tempItem.size);
        const maximumSize = itemWithMaximumSize ? itemWithMaximumSize.size : 0;

        const indexedQuestions = this.questions.map((q, i) => Object.assign(q.clone(), {index: i}));
        const {
            SurveyStarRating: starRatingQuestions,
            SurveyFreeText: freeTextQuestions,
            SurveyMultipleChoice: multipleChoiceQuestions,
            SurveyDate: dateQuestions
        } = _.groupBy(indexedQuestions, item => item.get("type"));

        if (starRatingQuestions) {
            starRatingStats = starRatingQuestions
                .map(rating => {
                    const index = rating.index;
                    //e.g. `starsCount["2"] = 10`, means that `3 stars` (since arrays start from `0`, subtract 1) was selected 10 times
                    const starsCountPadding = new Array(maximumSize).fill(0);
                    const filteredAnswers = starRatingAnswers.filter(subItem => subItem.questionIndex === index && subItem.normalizedRating);
                    const ssrCount = filteredAnswers.length;
                    const starsCount = Object.assign(starsCountPadding, _.countBy(filteredAnswers, rt => rt.size - 1));
                    const score = filteredAnswers.reduce((acc, {normalizedRating}) => acc + normalizedRating, 0);
                    return {ssrCount, stars: starsCount, score, index};
                });

            const mappedRatingQuestions = starRatingQuestions.map(item => {
                const {score, ssrCount} = starRatingStats.find(({index}) => index === item.index);
                return {
                    index: item.index,
                    title: item.get('title'),
                    required: item.get('required'),
                    normalizedRating: (score / ssrCount),
                    size: item.get('size'),
                    timesFilledIn: ssrCount,
                    type: "SurveyAnswerStarRating"
                };
            });
            questionAnswer.push(...mappedRatingQuestions);
        }
        if (freeTextQuestions) {
            const freeTextStats = freeTextQuestions.map(item => {
                const index = item.index;
                const filteredAnswers = freeTextAnswers.filter(({questionIndex}) => questionIndex === index);
                const sftCount = filteredAnswers.length;
                const textAnswers = filteredAnswers.map(item => item.textAnswer);
                const subscription = sftCount ? filteredAnswers[0].subscription : undefined;
                return {sftCount, textAnswers, subscription, index};
            });

            const mappedTextQuestions = freeTextQuestions.map(item => {
                const {sftCount, textAnswers, subscription} = freeTextStats.find(({index}) => index === item.index);
                return {
                    index: item.index,
                    title: item.get('title'),
                    required: item.get('required'),
                    textQuestion: item.get('textQuestion'),
                    textAnswers: textAnswers,
                    timesFilledIn: sftCount,
                    subscription: subscription,
                    type: "SurveyAnswerFreeText"
                };
            });
            questionAnswer.push(...mappedTextQuestions);
        }
        if (dateQuestions) {
            const dateStats = dateQuestions.map(item => {
                const index = item.index;
                const filteredAnswers = surveyDateAnswers.filter(({questionIndex}) => questionIndex === index);
                const sftCount = filteredAnswers.length;
                const dateAnswers = filteredAnswers.map(item => item.date);
                const subscription = sftCount ? filteredAnswers[0].subscription : undefined;
                return {sftCount, dateAnswers, subscription, index};
            });

            const mappedDateQuestions = dateQuestions.map(item => {
                const {sftCount, dateAnswers, subscription} = dateStats.find(({index}) => index === item.index);
                return {
                    index: item.index,
                    title: item.get('title'),
                    required: item.get('required'),
                    textQuestion: item.get('textQuestion'),
                    dateAnswers: dateAnswers,
                    timesFilledIn: sftCount,
                    subscription: subscription,
                    type: "SurveyAnswerDate"
                };
            });
            questionAnswer.push(...mappedDateQuestions);
        }
        if (multipleChoiceQuestions) {
            const multipleChoiceStats = multipleChoiceQuestions.map(item => {
                const index = item.index;
                const filteredAnswers = multipleChoiceAnswers.filter(subItem => subItem.questionIndex === index);
                var smcCount = filteredAnswers.length;
                const choicesCountMap = filteredAnswers.map(subItem => _.countBy(subItem.choices, _.identity))
                    .reduce(
                        (acc, next) => {
                            Object.keys(next).forEach(
                                k => Object.assign(acc, {[k]: acc[k] ? next[k] + acc[k] : next[k]})
                            );
                            return acc;
                        }, {});
                const choicesCount = item.get('choices').map((choice, idx) => ({
                    text: choice,
                    count: choicesCountMap[idx] || 0
                }));
                return {smcCount, choicesCount, index};
            });

            const mappedMultipleChoiceQuestions = multipleChoiceQuestions.map(item => {
                const {smcCount, choicesCount} = multipleChoiceStats.find(({index}) => index === item.index);
                return {
                    index: item.index,
                    title: item.get('title'),
                    required: item.get('required'),
                    textQuestion: item.get('textQuestion'),
                    choices: choicesCount,
                    timesFilledIn: smcCount,
                    type: "SurveyAnswerMultipleChoice"
                };
            });
            questionAnswer.push(...mappedMultipleChoiceQuestions);
        }

        return {questionAnswer, starRatingStats};
    }

    fillInCharts(questionAnswer, starRatingStats, colors) {

        let self = this, canvas, ctx, data;
        questionAnswer.forEach(function (item) {
            const {index, normalizedRating, choices} = item;
            if (choices) {

                let i = 0;
                data = choices.map(choice => ({
                    value: choice.count,
                    color: colors[i++],
                    scaleShowLabels: false,
                    label: choice.text
                }));

                canvas = $(`#multipleChoicePie${index}`).get(0);
                ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                const total = data.map(d => d.value).reduce((a, b) => a + b, 0);

                const myChart = new Chart(ctx).Doughnut(data, self.setCustomTooltipAndReturnOptions(index, total));
            } else if (normalizedRating) {
                data = {};
                let datasets = starRatingStats.filter(srs => srs.index === index).map(srs => ({
                    label: srs.index,
                    fillColor: "#FF9900",
                    strokeColor: "#FF9900",
                    pointColor: "#FF9900",
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: "#FF9900",
                    data: srs.stars
                }));

                var c = 0;
                var labels = new Array(item.size)
                    .fill(0)
                    .map(() => c === 0 ? `${1 + c++} ${i18n.t("survey.stars")}` : (`${1 + c++} ${i18n.t("survey.stars_plural")}`));

                data = {
                    labels: labels,
                    datasets: datasets
                };

                var options = {
                    bezierCurve: false,
                    datasetFill: false,
                    responsive: true,
                    maintainAspectRatio: false
                };

                canvas = $(`#starRatingChart${index}`).get(0);
                if (canvas) {
                    ctx = canvas.getContext("2d");
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    new Chart(ctx).Bar(data, options);
                }
            }
        });
    }

    previousAnswer(event) {
        //reference to this view, that we pass on the event binding
        if (event.data.isAnimationOn) {
            return;
        }
        event.data.isAnimationOn = true;
        var index = $(event.currentTarget).attr("data-index");
        var answersCount = $(event.currentTarget).attr("data-answers-count");

        var $2 = $(`.freeTextAnswer${index}`);
        var elWidth = $2.css("width");
        var soloWidth = parseInt(elWidth) / parseInt(answersCount);
        var marginLeft = $2.css("margin-left");

        if (parseInt(elWidth) > parseInt(answersCount) * soloWidth) {
            elWidth = parseInt(answersCount) * soloWidth; //used to ensure no "more" px will be added in margin (in case of odd count of answers)
        }
        if (parseInt(marginLeft) >= 0) {
            $.Notify.show(i18n.t("survey.nopreviousanswer"));
            event.data.isAnimationOn = false;
            $2.css("margin-left", 0);
        } else {
            var result = (parseInt(marginLeft) + soloWidth);
            $2.animate({
                marginLeft: `${result}px`
            }, 600, () => {
                var $3 = $(".freeTextAnswer" + index);
                var currentMarginLeft = $3.css("margin-left");
                if (currentMarginLeft !== `${result}px`) {
                    $3.css("margin-left", `${result}px`);
                }
                event.data.isAnimationOn = false;
            });
        }
    }

    nextAnswer(event) {
        var self = event.data; //reference to this view, that we pass on the event binding
        if (self.isAnimationOn) {
            return;
        }
        self.isAnimationOn = true;
        var index = $(event.currentTarget).attr("data-index");
        var answersCount = $(event.currentTarget).attr("data-answers-count");

        var $2 = $('.freeTextAnswer' + index);
        var elWidth = $2.css("width");
        var soloWidth = parseInt(parseInt(elWidth) / parseInt(answersCount));
        var marginLeft = $2.css("margin-left");

        if (parseInt(elWidth) > parseInt(answersCount) * soloWidth) {
            elWidth = parseInt(answersCount) * soloWidth; //used to ensure no "more" px will be added in margin (in case of odd count of answers)
        }
        if (Math.abs(parseInt(marginLeft) - soloWidth) >= parseInt(elWidth)) {
            $.Notify.show(i18n.t("survey.nonextanswer"));
            self.isAnimationOn = false;
        } else {
            var result = parseInt(marginLeft) - parseInt(soloWidth);

            $2.animate({
                marginLeft: `${result}px`
            }, 600, function () {
                var $3 = $(`.freeTextAnswer${index}`);
                var currentMarginLeft = $3.css("margin-left");
                if (currentMarginLeft !== `${result}px`) {
                    $3.css("margin-left", `${result}px`);
                }
                self.isAnimationOn = false;
            });
        }
    }

    setCustomTooltipAndReturnOptions(index, timesFilledIn) {
        return {
            responsive: false,
            scaleShowLabels: false,
            percentageInnerCutout: 75,
            showTooltips: true,
            pointHitDetectionRadius: 1,
            customTooltips(tooltip) {
                var tooltipEl = $(`#chartjs-tooltip${index}`);

                if (!tooltip) {
                    tooltipEl.css({
                        opacity: 0
                    });
                    return;
                }

                var colonLocation = tooltip.text.lastIndexOf(':');
                var textUpToColon = tooltip.text.substring(0, colonLocation + 1);
                var textAfterColon = tooltip.text.substring(colonLocation + 1);
                var value = parseInt(textAfterColon);
                var percentage = (value / timesFilledIn * 100).toFixed(0);

                var innerHtml = `<div class="chartjs-tooltip-section">` +
                    `<span class="chartjs-tooltip-key" style="color:#000 !important; width:150px">${textUpToColon} ${percentage}%</strong></span>` +
                    `</div>`;

                tooltipEl.css({
                    opacity: 1,
                    fontFamily: tooltip.fontFamily,
                    fontSize: tooltip.fontSize,
                    fontStyle: tooltip.fontStyle,
                    height: "70px",
                    width: "100px",
                    textAlign: "center",
                    overflow: "hidden",
                    position: "absolute",
                    top: "calc(50% - 15px)",
                    left: "calc(50% - 50px)",
                    margin: "0px auto",
                    display: "table-cell",
                    verticalAlign: "middle"
                });
                tooltipEl.html(innerHtml);
            }
        };
    }

    loadVoucherReport() {
        this.VoucherRedemptionCollection.url = `/CampaignCloud/Report/${this.serviceId}/getVoucherReportPerPage`;
        console.info("Fetching voucher redemptions");
        return this.VoucherRedemptionCollection.getFirstPage();
    }

    async loadSurveyReport() {
        this.SurveyCompletionCollection.url = `/CampaignCloud/Report/${this.serviceId}/getSurveyReportPerPage`;
        console.info("Fetching survey completions");
        const firstPage = await this.SurveyCompletionCollection.getFirstPage();
        await this.fillInAllSurveyAnswers();
        const resp = this.fillInQuestionAnswerStarsChart(this.allSurveyAnswers);
        const questionAnswer = _.sortBy(resp.questionAnswer, ({index}) => index); //get data for questions' answers
        const starsChart = resp.starRatingStats; //get data for stars' answers

        const maxChoices = questionAnswer
            .filter(q => q.choices)
            .map(q => q.choices.length)
            .reduce((memo, cl) => memo > cl ? memo : cl, 0);

        const colors = ["#FF3333", "#FF9900", "#F2DB00", "#00CC66",
            "#0099FF", "#C60240", "#0D3A19", "#261420", "#0C4DE8",
            "#827F1D", "#0FFF2B", "#FF5CA6", "#C9AB6F", "#64CDDD"];

        function* randomColorGenerator(colors) {
            while (true) {
                const randColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
                if (!colors.includes(randColor))
                    yield randColor;
            }
        }

        const rcg = randomColorGenerator(colors);

        for (let z = colors.length; z <= maxChoices; z++) {
            colors.push(rcg.next().value);
        }
        this.tempSurveyComponentsStatsTemplate = this.surveyComponentsStatsTemplate({
            components: questionAnswer,
            colors
        });

        if (this.service === "Survey") {
            if (!_.isEmpty(this.allSurveyAnswers)) {
                $("#componentsStats").html(this.tempSurveyComponentsStatsTemplate);

                $('.previousAnswer').on('click', this, this.previousAnswer);
                $('.nextAnswer').on('click', this, this.nextAnswer);

                this.fillInCharts(questionAnswer, starsChart, colors); //fill charts with stats
            }
        }
        return firstPage;
    }

    loadOptinReport() {
        this.OptinAcquisitionsCollection.url = `/CampaignCloud/Report/${this.serviceId}/getOptinReportPerPage`;
        console.info("Fetching optin acquisitions");
        return this.OptinAcquisitionsCollection.getFirstPage();
    }

    loadInstantWinReport() {
        this.InstantWinAcquisitionsCollection.url = `/CampaignCloud/Report/${this.serviceId}/getOptinReportPerPage`;
        console.info("Fetching instantWin acquisitions");
        return this.InstantWinAcquisitionsCollection.getFirstPage();
    }

    loadPayPalPaymentReport() {
        this.PayPalPaymentBuyersCollection.url = `/CampaignCloud/Report/${this.serviceId}/getOptinReportPerPage`;
        console.info("Fetching pay pal payments");
        return this.PayPalPaymentBuyersCollection.getFirstPage();
    }
}

export default ServiceReportView;